const API_BASE_URL = '/api/v3';
const API_V4_BASE_URL = '/api/v4';
export default {
    API_BASE_URL: API_BASE_URL,

    API_PUBLIC_ORDER_FILE_DOWNLOAD_TOKEN_BY_SECRET: API_BASE_URL + '/public/orderFiles/:secret/downloadToken',

    API_WECHAT_OAUTH_URL: API_BASE_URL + '/auth/wechat/oauthURL',
    API_WECHAT_OAUTH_LOGIN: API_BASE_URL + '/auth/wechat/oauthLogin',
    API_OPS_LOGIN: API_BASE_URL + '/auth/opsLogin',
    API_OPS_LOGIN_QRCODE_INIT: API_BASE_URL + '/auth/qrcode',
    API_OPS_QRLOGIN: API_BASE_URL + '/auth/opsQRLogin',
    API_OPS_FAKE_LOGIN: API_BASE_URL + '/ops/assumeEmployees/fakeLogin',

    API_ME: API_BASE_URL + '/me',
    API_ME_EDIT_PASSWORD: API_BASE_URL + '/me/editPassword',
    API_ME_UPDATE_SETTINGS: API_BASE_URL + '/me/updateSettings',
    API_ME_UPDATE_AUTO_LOGIN_DATA: API_BASE_URL + '/me/updateAutoLoginData',
    API_OPS_ASSUME_EMPLOYEES: API_BASE_URL + '/ops/assumeEmployees',

    API_MAIL_SEND_ORDER_FILE_DOWNLOAD_MSG: API_BASE_URL + '/mail/orderFileDownload',

    API_WECHAT_USERS_BIND_EMPLOYEE: API_BASE_URL + '/business/wechatUsers/bindEmployee',
    API_WECHAT_USERS_BIND_ORDER: API_BASE_URL + '/business/wechatUsers/bindOrder',
    API_WECHAT_USERS_QRLOGIN_CONFIRM: API_BASE_URL + '/business/wechatUsers/qrLoginConfirm',
    API_WECHAT_USERS_UPDATE_PHONE: API_BASE_URL + '/business/wechatUsers/updatePhone',
    API_WECHAT_USER_ORDERS: API_BASE_URL + '/business/orders',
    API_WECHAT_USER_ORDER_FILE_DOWNLOAD_TOKEN: API_BASE_URL + '/business/orderFiles/downloadToken',
    API_CUSTOMER_CONTACT_INFO_GDT_IMPORT: API_BASE_URL + '/business/customerContactInfos/importGDT',
    API_CUSTOMER_CONTACT_INFO_IMPORT_PHONES: API_BASE_URL + '/business/customerContactInfos/importPhones',
    API_COUPONS: API_BASE_URL + '/business/coupons',
    API_CUSTOMER_COUPONS: API_BASE_URL + '/business/customerCoupons',
    API_CONTACT_FORMS: API_BASE_URL + '/business/contactForms',

    API_CUSTOMER_CONTACT_INFO_RESEND_WX_MSG: '/api/v2/customerContactInfo/notify/',
    
    API_WECHAT_MP_USERS: API_BASE_URL + '/business/wechatMPUsers',
    API_WECHAT_MP_USERS_FROM_WX: API_BASE_URL + '/ops/wechat/users',

    API_OPS_DBA: API_BASE_URL + '/ops/dba',

    API_OPS_DICTS: API_BASE_URL + '/ops/dicts',
    API_OPS_DICTS_TYPES: API_BASE_URL + '/ops/dicts/types',
    API_OPS_DICTS_PERMS: API_BASE_URL + '/ops/dicts/perms',
    API_OPS_DICTS_SYNC_WEPAY_ACCOUNT_PHONES: API_BASE_URL + '/ops/dicts/syncWepayAccountPhones',
    API_OPS_DEPARTMENTS: API_BASE_URL + '/ops/departments',

    API_OPS_EMPLOYEES: API_BASE_URL + '/ops/employees',
    API_OPS_EMPLOYEES_ORDERS: API_BASE_URL + '/ops/employees/orders',
    API_OPS_EMPLOYEES_AUDITOR_ORDERS: API_BASE_URL + '/ops/employees/auditorOrders',
    API_OPS_EMPLOYEES_PERFORMANCES: API_BASE_URL + '/ops/employees/performances',
    API_OPS_SALORS_PERFORMANCES: API_BASE_URL + '/ops/salors/performances',
    API_OPS_EMPLOYEES_PERMISSIONS: API_BASE_URL + '/ops/employees/permissions',
    API_OPS_EMPLOYEES_UNBIND_WECHAT_USER: API_BASE_URL + '/ops/employees/unbindWechatUser',
    API_OPS_EMPLOYEES_BIND_WECHAT_USER: API_BASE_URL + '/ops/employees/bindWechatUser',
    API_OPS_EMPLOYEES_LOCK_PUNCHIN_CONFIRMS: API_BASE_URL + '/ops/employees/lockPunchinConfirms',
    API_OPS_EMPLOYEES_CHECK_PUNCHIN_VACATION: API_BASE_URL + '/ops/employees/checkPunchinVacation',
    API_OPS_EMPLOYEES_DELETE_PUNCHIN_VACATION: API_BASE_URL + '/ops/employees/deletePunchinVacation',
    API_OPS_EMPLOYEES_BIND_QR_URL: API_BASE_URL + '/ops/employees/getBindQRURL',
    API_OPS_EMPLOYEES_UPDATE_EXTRA: API_BASE_URL + '/ops/employees/updateExtra',

    API_CRM_BLACK_LIST: API_BASE_URL + '/crm/blacklist',

    API_CRM_COMPANY_PHONES: API_BASE_URL + '/crm/companyPhones',
    API_CRM_COMPANY_PHONES_EXPORTCSV: API_BASE_URL + '/crm/companyPhones/exportCSV',
    API_CRM_COMPANY_PHONES_NEW_ITEM_STATE: API_BASE_URL + '/crm/companyPhones/editNewItemState',
    API_CRM_COMPANY_PHONES_FREQUENTS: API_BASE_URL + '/crm/companyPhones/frequents',
    API_CRM_SALOR_DAILY_LOGS: API_BASE_URL + '/crm/salorDailyLogs',
    URL_CRM_SALOR_DAILY_LOGS_DATE_RANGE_SUMMARY: API_BASE_URL + '/crm/salorDailyLogs/dateRangeSummary',
    
    API_CRM_CUSTOMERS: API_BASE_URL + '/crm/customers',

    API_OPS_BUSINESS_USERS: API_BASE_URL + '/business/users',
    API_OPS_BUSINESS_USERS_AUDIT: API_BASE_URL + '/business/users/audit',

    API_OPS_ORDERS: API_BASE_URL + '/ops/orders',
    API_OPS_SIMPLE_ORDERS: API_BASE_URL + '/ops/simpleOrders',
    API_OPS_ORDER_SERVICE_PRICES: API_BASE_URL + '/ops/orderServicePrices',
    API_OPS_ORDERS_CREATE_QR: API_BASE_URL + '/ops/orders/createQR',
    API_OPS_ORDERS_EDIT_STAR_STATE: API_BASE_URL + '/ops/orders/editStarState',
    API_OPS_ORDERS_EDIT_BOUTIQUE_STATE: API_BASE_URL + '/ops/orders/editBoutiqueState',
    API_OPS_ORDERS_EDIT_REJECTED_EMPLOYEES: API_BASE_URL + '/ops/orders/editRejectedEmployees',
    API_OPS_ORDERS_RANDOM_CHECK_CLAIM: API_BASE_URL + '/ops/orders/randomCheckClaim',
    URL_ORDERS_SERVICE_PRICE_EXTRA_EDIT: API_BASE_URL + '/ops/orders/editServicePriceExtra',
    URL_ORDERS_GROUP_LEADER_CLAIM: API_BASE_URL + '/ops/orders//groupLeaderClaim',

    URL_OPS_DATACENTER_STATISTICS_ORDER_BASE_CITY: API_BASE_URL + '/datacenter/statistics/orders/baseCity',
    URL_OPS_DATACENTER_STATISTICS_ORDER_BASE_CITY_PAYMENTS: API_BASE_URL + '/datacenter/statistics/orders/baseCity/payments',
    URL_OPS_DATACENTER_STATISTICS_ORDER_BASE_CITY_SERVICE_TYPES: API_BASE_URL + '/datacenter/statistics/orders/baseCity/serviceTypes',
    URL_OPS_DATACENTER_STATISTICS_ORDER_SALOR: API_BASE_URL + '/datacenter/statistics/orders/salor',
    URL_OPS_DATACENTER_STATISTICS_PAYMENTS_OUTPUT_TYPES: API_BASE_URL + '/datacenter/statistics/payments/outputTypes',

    API_OPS_ORDERS_AUDIT_LOGS: API_BASE_URL + '/ops/orderAuditLogs',
    API_OPS_ORDERS_AUDIT_LOGS_CLAIM: API_BASE_URL + '/ops/orderAuditLogs/claim',
    API_OPS_ORDERS_AUDIT_LOGS_ATTACH_FILES: API_BASE_URL + '/ops/orderAuditLogs/attachFiles',
    API_OPS_ORDERS_AUDIT_LOGS_EXPORT: API_BASE_URL + '/ops/orderAuditLogs/export',
    API_OPS_ORDERS_AUDIT_LOGS_DEPARTMENT_CHECK: API_BASE_URL + '/ops/orderAuditLogs/departmentCheck',
    API_OPS_ORDERS_AUDIT_LOGS_DEPARTMENT_FINAL_CHECK: API_BASE_URL + '/ops/orderAuditLogs/departmentFinalCheck',
    API_OPS_ORDERS_AUDIT_LOGS_FINAL_CHECK: API_BASE_URL + '/ops/orderAuditLogs/finalCheck',
    API_OPS_ORDERS_AUDIT_LOGS_RESET_FINAL_CHECK: API_BASE_URL + '/ops/orderAuditLogs/resetFinalCheck',
    
    API_OPS_ORDERS_FILES: API_BASE_URL + '/ops/orderFiles',
    API_OPS_ORDERS_FILES_APPLY_BOUTIQUE: API_BASE_URL + '/ops/orderFiles/applyBoutique',
    API_OPS_ORDERS_FILES_AUDIT_BOUTIQUE: API_BASE_URL + '/ops/orderFiles/auditBoutique',
    API_OPS_ORDERS_FILES_UPDATE_CUSTOMER_FIRST_DOWNLOADTS: API_BASE_URL + '/ops/orderFiles/updateCustomerFirstDownloadTS',
    
    API_OPS_ORDERS_EXPORT: API_BASE_URL + '/ops/orderExport',
    API_OPS_ORDERS_EXPORT_RESET_STATE: API_BASE_URL + '/ops/orderExport/resetState',

    API_OPS_ELEC_INVOICE_LOGS: API_BASE_URL + '/ops/elecInvoiceLogs',
    API_OPS_ELEC_INVOICE_LOGS_EDIT_RED_CHARGE_AGAINST: API_BASE_URL + '/ops/elecInvoiceLogs/editRedChargeAgainst',

    API_OPS_INVOICE_APPLY_LOGS: API_BASE_URL + '/org/invoiceApplyLogs',

    API_OPS_ORDER_DAILY_CAPACITY_STATISTICS: API_BASE_URL + '/org/orderDailyCapacity/statistics',
    API_OPS_ORDER_DAILY_CAPACITY_DEFAULT: API_BASE_URL + '/org/orderDailyCapacity/default',
    API_OPS_ORDER_DAILY_CAPACITY: API_BASE_URL + '/org/orderDailyCapacity',

    API_OPS_RESOURCES_TYPES: API_BASE_URL + '/ops/resources/types',
    API_OPS_RESOURCES: API_BASE_URL + '/ops/resources',
    API_OPS_RESOURCES_GROUP: API_BASE_URL + '/ops/resources/group',
    API_OPS_RESOURCES_PUBLISH: API_BASE_URL + '/ops/resources/publish',

    API_OPS_BUDGET_MATERIAL_PRICES: API_BASE_URL + '/org/budgetMaterialPrices',
    API_OPS_BUDGET_MATERIAL_PRICES_COLUMN_VALUES: API_BASE_URL + '/org/budgetMaterialPrices/columnValues',
    
    API_OPS_ORDER_PAYMENTS_RECEIVE_ACCOUNTS: API_BASE_URL + '/ops/orderPayments/receiveAccounts',
    API_OPS_ORDER_PAYMENTS: API_BASE_URL + '/ops/orderPayments',
    API_OPS_ORDER_PAYMENTS_EDIT_FINANCE_PAYMENT: API_BASE_URL + '/ops/orderPayments/editFinancePayment',
    API_OPS_ORDER_PAYMENTS_EXPORTCSV: API_BASE_URL + '/ops/orderPayments/exportCSV',
    API_OPS_ORDER_PAYMENTS_MANUAL_CHECK: API_BASE_URL + '/ops/orderPayments/manualCheck',
    API_OPS_ORDER_PAYMENTS_UPDATE_CORP_CONFIRM_FILE: API_BASE_URL + '/ops/orderPayments/updateCorpConfirmFile',
    API_OPS_ORDER_PAYMENTS_AUDIT: API_BASE_URL + '/ops/orderPaymentsAudit',
    API_OPS_ORDER_PAYMENTS_AUDIT_CHECK: API_BASE_URL + '/ops/orderPaymentsAudit/check',
    API_OPS_ORDER_PAYMENTS_AUDIT_PRECHECK: API_BASE_URL + '/ops/orderPaymentsAudit/preCheck',
    API_OPS_ORDER_PAYMENTS_AUDIT_UPDATE_CORP_CONFIRM_FILE: API_BASE_URL + '/ops/orderPaymentsAudit/updateCorpConfirmFile',
    API_OPS_ORDER_PAYMENTS_ADD_WX_INCOME: API_BASE_URL + '/ops/orderPayments/wx/income',
    API_OPS_ORDER_PAYMENTS_ADD_WX_EXPEND: API_BASE_URL + '/ops/orderPayments/wx/expend',
    API_OPS_ORDER_PAYMENTS_ADD_WX_WITHDRAW: API_BASE_URL + '/ops/orderPayments/wx/withdraw',
    API_OPS_ORDER_PAYMENTS_ADD_INVOICE_RECORD: API_BASE_URL + '/ops/orderPayments/addInvoiceRecord',
    API_OPS_ORDER_PAYMENTS_RECEIVE_ACCOUNT_BALANCES: API_BASE_URL + '/ops/orderPayments/receiveAccountsBalances',
    API_OPS_ORDER_PAYMENTS_NOT_MATCH_DICT_WECHAT_ACCOUNTS: API_BASE_URL + '/ops/orderPayments/notMatchDictWechatAccounts',
    API_OPS_ORDER_PAYMENTS_CHANGE_BALANCE: API_BASE_URL + '/ops/orderPayments/changeBalance',
    API_OPS_ORDER_PAYMENTS_SPLIT: API_BASE_URL + '/ops/orderPayments/split',
    API_OPS_PAYMENT_ACCOUNT_SETTLEMENTS: API_BASE_URL + '/ops/paymentAccountSettlements',
    API_OPS_PAYMENT_ACCOUNT_SETTLEMENTS_CONFIRM: API_BASE_URL + '/ops/paymentAccountSettlements/confirm',

    API_OPS_ORDERS_STATISTICS_COMMON: API_BASE_URL + '/ops/orderStatistics/common',
    API_OPS_ORDERS_STATISTICS_SERVICE_PRICES: API_BASE_URL + '/ops/orderStatistics/servicePriceList',
    API_OPS_ORDERS_STATISTICS_RANDOM_CHECK: API_BASE_URL + '/ops/orderStatistics/randomCheckList',
    API_OPS_ORDERS_STATISTICS_DAYS: API_BASE_URL + '/ops/orderStatistics/days',
    API_OPS_ORDERS_STATISTICS_EXPORT: API_BASE_URL + '/ops/orderStatistics/exportCSV',

    API_OPS_CONTRACTS_INIT_PDF: API_BASE_URL + '/ops/contracts/initPDF',
    API_OPS_CONTRACTS_DETECT_PDF: API_BASE_URL + '/ops/contracts/detectPDF',
    API_OPS_CONTRACTS_DOWNLOAD_PDF: API_BASE_URL + '/ops/contracts/downloadPDF',

    API_CLOUD_OSS_FILES: API_BASE_URL + '/cloud/ossFiles',
    API_CLOUD_OSS_FILES_DELETE: API_BASE_URL + '/cloud/ossFiles/delete',

    API_ORG_ADOPTED_PAYMENT_LOGS: API_BASE_URL + '/org/adoptedPaymentLogs',
    API_ORG_ADOPTED_PAYMENT_LOGS_RELATE_TO_ORDER: API_BASE_URL + '/org/adoptedPaymentLogs/relateToOrder',

    API_ORG_DOC_MODULE_JOBS: API_V4_BASE_URL + '/order/docModuleJobs',
    API_ORG_DOC_MODULE_JOBS_ASSIGN: API_V4_BASE_URL + '/order/docModuleJobs/assign',
    API_ORG_DOC_MODULE_JOBS_UNASSIGN: API_V4_BASE_URL + '/order/docModuleJobs/unAssign',
    API_ORG_DOC_MODULE_JOBS_UPDATE_DOC_NUMBER: API_V4_BASE_URL + '/order/docModuleJobs/updateDocNumber',
    API_ORG_DOC_MODULE_JOB_MARK_FINISH: API_V4_BASE_URL + '/order/docModuleJobs/markFinish',
    API_ORG_DOC_MODULE_JOB_COMMENTS: API_V4_BASE_URL + '/order/docModuleJobs/comments',
    API_ORG_DOC_MODULE_JOB_FILES: API_V4_BASE_URL + '/order/docModuleJobs/files',
    API_ORG_DOC_MODULE_JOB_FILES_AUDIT: API_V4_BASE_URL + '/order/docModuleJobs/files/audit',
    API_ORG_DOC_MODULE_JOB_STATISTICS: API_V4_BASE_URL + '/order/docModuleJobs/statistics',
    API_ORG_DOC_MODULE_JOB_OPERATOR_STATISTICS: API_V4_BASE_URL + '/order/docModuleJobs/operatorStatistics',

    API_ORG_DOCER_SCORE: API_V4_BASE_URL + '/order/docerScore',
    API_ORG_DOCER_SCORE_DETAILS: API_V4_BASE_URL + '/order/docerScore/details',
    API_ORG_DOCER_SCORE_CONFIGS: API_V4_BASE_URL + '/order/docerScore/configs',
    API_ORG_DOCER_SCORE_CONFIGS_DELETE: API_V4_BASE_URL + '/order/docerScore/configs/delete',


    API_ORG_CA: API_V4_BASE_URL + '/order/ca',
    API_ORG_CA_STATISTICS: API_V4_BASE_URL + '/order/ca/statistics',

    API_ZHENGCAI_STATISTIC_COMMON: API_V4_BASE_URL + '/zhengcai/orders/statistics/common',
    API_ZHENGCAI_DATE_RANGE_PAYMENTS_STATISTIC: API_BASE_URL + '/datacenter/statistics/zhengcai/payments',
}



// WEBPACK FOOTER //
// ./src/store/apis.js